//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.InheritableToolDepBuilder.js";
let d=[[[0,"ApplyCornersSmoothing",1,0],[0,"ApplyCornersSmoothingTransfers",1,0],[0,"EngRetMaxToolAxisChange",1,0],[0,"EngRetTolerance",1,0],[0,"EngRetToleranceSource",1,0],[1,"MaxStepoverDistance",0,"CAM.InheritableToolDepBuilder",0],[0,"OverrideWithSmoothConnections",1,0],[0,"OverrideWithSmoothConnectionsType",1,0],[1,"PartSafeClearance",0,"CAM.InheritableToolDepBuilder",0],[1,"RegionDistance",0,"CAM.InheritableToolDepBuilder",0],[1,"SmoothHeight",0,"CAM.InheritableToolDepBuilder",0],[1,"SmoothLength",0,"CAM.InheritableToolDepBuilder",0],[1,"SmoothingRadius",0,"CAM.InheritableToolDepBuilder",0],[0,"TransferMaxToolAxisChange",1,0],[0,"TransferTolerance",1,0],[0,"TransferToleranceSource",1,0]],[],[]];
SPLM.CAM.NcmSmoothingBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.NcmSmoothingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.NcmSmoothingBuilder.OverrideSmoothConnections = Object.freeze({
    "Off" : "Off", "TangentSpline" : "TangentSpline", "RotarySpline" : "RotarySpline", "RotaryAroundAxisSpline" : "RotaryAroundAxisSpline"});

SPLM.CAM.NcmSmoothingBuilder.SmoothToleranceSources = Object.freeze({
    "MinimizePoints" : "MinimizePoints", "Cutting" : "Cutting", "Specify" : "Specify"});

export default SPLM;